<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :selection="false"
      :columns="columns"
      :handless="handle"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      label-width="100px"
      cnames="终端状态"
    />
    <el-dialog
      v-dialogDrag
      title="电站授权"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="60%"
      center
    >
      <el-form :model="form" label-width="120px">
        <el-form-item label="电桩运营商">
          <STree v-model="form.operatorIds" :data="operatortree" style="width: 400px" />
        </el-form-item>
        <el-form-item label="选择电站">
          <STree v-model="form.stationIds" :data="stationtree" style="width: 400px" />
        </el-form-item>
        <el-form-item label="授权机构">
          <STree v-model="form.mechanismIds" :data="mechanismtree" style="width: 400px" />
        </el-form-item>
      </el-form>
      <div class="btns" style="margin-top: 30px;display: flex;align-items: center;justify-content: center;">
        <el-button @click="cancel1">取消</el-button>
        <el-button type="primary" @click="save1">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog v-dialogDrag title="批量更新" :visible.sync="dialogVisible2" :close-on-click-modal="false" width="60%" center>
      <STable
        ref="tableref2"
        :url="url"
        :selection="true"
        :columns="columns"
        :toolbar="toolbar2"
        label-width="100px"
      />
      <div class="btns" style="margin-top: 30px;display: flex;align-items: center;justify-content: center;">
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog v-dialogDrag title="远程升级" :visible.sync="dialogVisible3" :close-on-click-modal="false" width="40%" center>
      <el-form ref="formUpdata" :model="formUpdata" :rules="rules" label-width="150px" style=" margin-top: 20px;">
        <el-form-item label="电站名称" prop="stationName" style="width: 90%;">
          <div>{{ formUpdata.stationName }}</div>
        </el-form-item>
        <el-form-item label="升级版本" prop="version" style="width: 90%;">
          <el-select v-model="formUpdata.version" filterable placeholder="请选择升级版本号" style="width:100%;">
            <el-option v-for="item in versionList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item style="margin-top:30px;width: 90%;text-align: center" label-width="0px">
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="save">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 配置分润弹窗 -->
    <el-dialog
      v-dialogDrag
      :title="'配置分润' + (profitStationName ? ' - ' + profitStationName : '')"
      :visible.sync="dialogVisibleProfit"
      :close-on-click-modal="false"
      width="720px"
      @closed="closeProfitDialog"
    >
      <el-form :model="profitForm" label-width="100px" size="small">
        <el-form-item label="分润模式">
          <el-radio-group v-model="profitForm.mode" @change="handleProfitModeChange">
            <el-radio label="PERCENT">按比例分润</el-radio>
            <el-radio label="FIXED">按固定金额分润</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <el-alert
        v-if="profitForm.mode === 'PERCENT'"
        title="比例模式下，各分润方比例之和为 100% 时表示全额分润"
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 12px"
      />

      <el-table :data="profitForm.list" border size="small" style="width: 100%">
        <el-table-column label="分润方" min-width="240">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.targetId"
              filterable
              :disabled="scope.$index === 0"
              placeholder="请选择分润方"
              style="width: 100%"
              @change="val => handleProfitTargetChange(scope.$index, val)"
            >
              <el-option
                v-for="item in shareArray"
                :key="item.id"
                :label="item.userName || item.nickName || item.loginName || item.id"
                :value="item.id"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column :label="profitForm.mode === 'PERCENT' ? '分润比例(%)' : '分润金额(元/度)'" min-width="180">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.share"
              type="number"
              :disabled="scope.$index === 0"
              :placeholder="profitForm.mode === 'PERCENT' ? '请输入比例' : '请输入金额'"
              @input="recalcOperator"
            >
              <template slot="append">{{ profitForm.mode === 'PERCENT' ? '%' : '元' }}</template>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.$index !== 0"
              type="text"
              class="red"
              @click="removeProfitRow(scope.$index)"
            >移除</el-button>
            <span v-else>运营商</span>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top: 12px">
        <el-button type="primary" plain size="small" @click="addProfitRow">添加分润方</el-button>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisibleProfit = false">取消</el-button>
        <el-button type="primary" size="small" :loading="profitSaving" @click="saveProfit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { HOST, EV_HOST } from '@/utils/host'
import fieldFilter from '@/utils/fieldFilter.js'
import { regionData, provinceAndCityData } from 'element-china-area-data'
export default {
  name: 'Guanliyuanyonghu',
  components: {},
  data() {
    return {
      dialogVisible3: false,
      id: '',
      formUpdata: {
        stationName: '',
        version: ''
      },
      rules: {
        version: [{ required: true, message: '请选择升级版本', trigger: 'change' }]
      },
      url: '/station/page',
      columns: [
        {
          label: '电站名称',
          prop: 'stationName'
        },
        {
          label: '当前费率',
          prop: 'money',
          width: '100px',
          template: (index, record) => {
            return this.getFloat(record.money) + '元/度'
          }
        },
        {
          label: '电站地址',
          prop: 'address'
        },
        {
          label: '运营商',
          prop: 'operatorName'
        },
        {
          label: '区划',
          prop: 'cityName'
        },
        {
          label: '场地属性',
          prop: 'siteProperties'
        },
        {
          label: '电站类型',
          prop: 'stationTypeValue'
        },
        {
          label: '绑定标签',
          prop: 'labelName'
        },
        {
          label: '开放时间',
          prop: 'busineHoursInstruction'
        },
        {
          label: '移动端可见',
          prop: 'appCanSee',
          template: function(index, reocrd) {
            return reocrd.appCanSee ? '可见' : '不可见'
          }
        },
        {
          label: '当前状态',
          prop: 'disable',
          template: function(index, reocrd) {
            return reocrd.disable ? "<div class='circle red'></div><span>停用</span>" : "<div class='circle green'></div><span>启用</span>"
          }
        }
      ],

      // 操作栏
      handle: {
        width: 100,
        btns: [
          {
            label: '查看',
            isPlant: true,
            permission: '',
            before: (index, record) => {
              // this.handle.btns[0].form = {};
              // console.log(record,111)
              // let data={
              //   id:record.id
              // }
              // this.$store.dispatch("form/handle",{
              //   url:"/station/getGunStatus",
              //   data:data,
              //   method:"get",
              //   callback:resp=>{
              //     this.handle.btns[0].form = resp
              //     // console.log(this.handle.btns[0].form,1111,resp)
              //   }
              // })
            }
          }
        ]
      },

      // 操作栏
      handles: {
        width: 470,
        btns: [
          {
            label: '修改',
            icon: 'el-icon-edit',
            permission: 'pile.station.update',
            handle: (resp) => {
              console.log(resp)
              this.$router.push({
                path: './revisePlant',
                query: { data: resp.id }
              })
            }
          },
          {
            label: '详情',
            icon: 'el-icon-view',
            permission: 'pile.station.details',
            handle: (resp) => {
              this.$router.push({
                path: './plantDetail',
                query: { data: resp.id }
              })
            }
          },
          {
            label: '停用',
            permission: 'pile.station.Enable',
            style: 'color:red',
            isShowFun: function(record) {
              return !record.disable
            },
            url: '/station/status',
            method: 'post',
            isConfirm: true,
            confirmText: '电站停用后电站内所有电桩将不可使用，是否继续？',
            before: function(index, record) {
              const ids = []
              ids.push(record.id)
              const p = {
                ids: ids
              }
              return p
            },
            handle: (resp) => {
              console.log('resp', resp)
              if (resp.length > 0) {
                this.$router.push('./addPile')
              }
              this.$refs.tableref.queryTable()
            }
          },
          {
            label: '启用',
            permission: 'pile.station.Enable',
            style: 'color:red',
            isShowFun: function(record) {
              return record.disable
            },
            url: '/station/status',
            method: 'post',
            isConfirm: true,
            confirmText: '是否启用该电站？',
            before: function(index, record) {
              const ids = []
              ids.push(record.id)
              const p = {
                ids: ids
              }
              return p
            },
            handle: (resp) => {
              console.log('resp', resp)
              if (resp.length > 0) {
                this.$router.push('./addPile')
              }
              this.$refs.tableref.queryTable()
            }
          },
          {
            label: '删除',
            icon: 'el-icon-delete',
            permission: 'pile.station.delete',
            style: 'color: red',
            url: '/station',
            method: 'delete',
            confirmText:
              '此操作会将电站下所有设备（电桩）一起删除，是否继续删除？',
            isConfirm: true,
            before: (index, records) => {
              const arr = []
              arr.push(records.id)
              return {
                ids: arr
              }
            },
            handle: () => {
              this.$notify({
                title: '成功',
                message: '删除成功',
                type: 'success'
              })
              this.$refs.tableref.queryTable()
            }
          },
          {
            label: '远程升级',
            permission: 'pile.station.upgrade',
            before: record => {
              this.formUpdata = {
                stationName: '',
                version: ''
              }
              this.dialogVisible3 = true
            },
            handle: (resp) => {
              this.id = resp.id
              this.formUpdata.stationName = resp.stationName
            }
          },
          {
            label: '周边设备',
            icon: 'el-icon-edit',
            permission: 'pile.station.Peripheral',
            handle: (resp) => {
              console.log(resp)
              this.$router.push({
                path: './plantRobot',
                query: { id: resp.id }
              })
            }
          },
          {
            label: '分润配置',
            icon: 'el-icon-wallet',
            permission: 'pile.station.update',
            handle: (resp) => {
              this.openProfitConfig(resp)
            }
          }
        ]
      },
      query: [
        {
          label: '电站名称',
          prop: 'name',
          placeholder: '请输入电站名称'
        },
        {
          label: '归属运营商',
          prop: 'operatorName',
          placeholder: '请输入归属运营商'
        },
        {
          label: '运营状态',
          prop: 'operateStatus',
          placeholder: '请选择运营状态',
          type: 'select',
          data: [
            {
              label: '待建设',
              value: '0'
            },
            {
              label: '新建中',
              value: '1'
            },
            {
              label: '待验收',
              value: '2'
            },
            {
              label: '运营中',
              value: '3'
            }
            // {
            //   label: "建设",
            //   value: "0",
            // },
            // {
            //   label: "经营中",
            //   value: "1",
            // },
            // {
            //   label: "暂停经营",
            //   value: "2",
            // },
          ]
        },
        {
          label: '启停状态',
          prop: 'disable',
          placeholder: '请选择状态',
          type: 'select',
          data: [
            {
              label: '启用',
              value: '0'
            },
            {
              label: '停用',
              value: '1'
            }
          ]
        },
        {
          label: '电站城市',
          prop: 'city',
          placeholder: '请选择电站城市',
          data: regionData,
          props: { checkStrictly: true, value: 'value' },
          type: 'cascader'
        },
        {
          label: '电站地址',
          prop: 'address',
          placeholder: '请输入电站地址'
        },
        {
          label: '场地属性',
          prop: 'siteProperties',
          placeholder: '请选择属性',
          type: 'select',
          data: [
            {
              label: '独立场站',
              value: '独立场站'
            },
            {
              label: '混合场站',
              value: '混合场站'
            }
          ]
        },
        {
          label: '移动端可见',
          prop: 'appCanSee',
          placeholder: '请选择是否可见',
          type: 'select',
          data: [
            {
              label: '可见',
              value: '1'
            },
            {
              label: '不可见',
              value: '0'
            }
          ]
        },
        {
          label: '电站类型',
          prop: 'stationType',
          placeholder: '请选择电站类型',
          type: 'select',
          data: [
            {
              label: '公共',
              value: '1'
            },
            {
              label: '个人',
              value: '50'
            },
            {
              label: '公交(专用)',
              value: '100'
            },
            {
              label: '环卫(专用)',
              value: '101'
            },
            {
              label: '物流(专用)',
              value: '102'
            },
            {
              label: '出租车(专用)',
              value: '103'
            },
            {
              label: '其他',
              value: '255'
            }
          ]
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'pile.station.add',
          type: 'primary',
          handle: (resp) => {
            this.$router.push('./addPlant')
          }
        }
      ],
      toolbar2: [
        {
          label: '远程升级',
          permission: '',
          url: '',
          method: '',
          before: record => {
            const ids = []
            ids.push(record.id)
            const updataDate = {
              ids: ids
            }
            return updataDate
          },
          handle: (resp) => {
            this.dialogVisible2 = false
            this.$refs.tableref2.queryTable()
          }
        }
      ],
      dialogVisible: false,
      dialogVisible2: false,
      form: {
        operatorIds: [],
        stationIds: [],
        mechanismIds: []
      },
      operatortree: [],
      stationtree: [],
      mechanismtree: [],
      versionList: [],
      dialogVisibleProfit: false,
      profitStationId: '',
      profitStationName: '',
      profitSaving: false,
      shareArray: [],
      profitForm: {
        mode: 'PERCENT',
        list: []
      }
    }
  },
  computed: {},
  mounted() {
    this.selectVersion()
    this.getAllOperator()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    // 获取版本列表
    selectVersion(val) {
      const data = {}
      this.$store.dispatch('form/handle', {
        url: '/alarm/firmware/selectFirmware',
        data: data,
        method: 'get',
        callback: (resp) => {
          const arr = []
          resp.forEach(item => {
            arr.push({
              label: item.version,
              value: item.id
            })
          })
          this.versionList = arr
          console.log(this.versionList)
        }
      })
    },
    // 获取分润方账号列表
    getAllOperator() {
      const data = {
        pageNo: 1,
        pageSize: 1000
      }
      this.$store.dispatch('form/handle', {
        url: '/user/page',
        data: data,
        method: 'get',
        callback: (resp) => {
          if (resp && resp.list && resp.list.length > 0) {
            this.shareArray = resp.list
          }
        }
      })
    },
    // 打开分润配置弹窗
    openProfitConfig(row) {
      this.profitStationId = row.id
      this.profitStationName = row.stationName
      this.$store.dispatch('form/handle', {
        url: '/station/getEditData',
        data: { id: row.id },
        method: 'get',
        callback: (resp) => {
          this.profitForm.mode = resp.profitMode || 'PERCENT'
          const list = [{ targetId: 'operator', share: '' }]
          if (resp.profitConfigs && resp.profitConfigs.length > 0) {
            resp.profitConfigs.forEach(item => {
              list.push({
                targetId: item.targetId,
                share: item.share
              })
            })
          }
          this.profitForm.list = list
          this.recalcOperator()
          this.dialogVisibleProfit = true
        }
      })
    },
    closeProfitDialog() {
      this.profitForm.list = []
      this.profitStationId = ''
      this.profitStationName = ''
    },
    handleProfitModeChange() {
      this.profitForm.list.forEach((item, i) => {
        if (i > 0) {
          item.share = ''
        }
      })
      this.recalcOperator()
    },
    handleProfitTargetChange(index, val) {
      const repeat = this.profitForm.list.filter(
        (item, i) => item.targetId === val && i !== index
      )
      if (repeat.length > 0) {
        this.$message.warning('该分润方已添加，请勿重复')
        this.profitForm.list[index].targetId = ''
      }
    },
    addProfitRow() {
      this.profitForm.list.push({
        targetId: '',
        share: ''
      })
    },
    removeProfitRow(index) {
      this.profitForm.list.splice(index, 1)
      this.recalcOperator()
    },
    // 运营商比例自动 = 100% - 其它分润方之和
    recalcOperator() {
      const list = this.profitForm.list
      if (!list || list.length < 1) {
        return
      }
      if (this.profitForm.mode === 'PERCENT') {
        let num = 100
        for (let i = 1; i < list.length; i++) {
          num = num - Number(list[i].share || 0)
        }
        const reg = /^\d+(?=\.{0,1}\d+$|$)/
        if (reg.test(num) && num >= 0) {
          list[0].share = num
        } else {
          list[0].share = ''
          this.$message.warning('所有分润方比例相加超出100%')
        }
      } else {
        list[0].share = ''
      }
    },
    // 保存分润配置
    saveProfit() {
      if (!this.profitStationId) {
        this.$message.warning('请选择场站')
        return
      }
      const validList = this.profitForm.list.filter(
        (item, i) => i > 0 && item.targetId && item.share !== '' && item.share !== null
      )
      for (const item of validList) {
        const share = Number(item.share)
        if (isNaN(share) || share < 0) {
          this.$message.warning('分润比例/金额必须为不小于 0 的数字')
          return
        }
        if (this.profitForm.mode === 'PERCENT' && share > 100) {
          this.$message.warning('比例模式下分润比例不能超过 100%')
          return
        }
      }
      const data = {
        relatedId: this.profitStationId,
        profitMode: this.profitForm.mode,
        profitConfigs: validList.map(item => ({
          targetId: item.targetId,
          share: Number(item.share)
        }))
      }
      this.profitSaving = true
      this.$store.dispatch('form/handle', {
        url: '/station/profitConfig',
        data: data,
        method: 'post',
        callback: (resp) => {
          this.profitSaving = false
          this.dialogVisibleProfit = false
          this.$message.success('分润配置保存成功')
          this.$refs.tableref.queryTable()
        },
        error: () => {
          this.profitSaving = false
        }
      })
    },
    cancel1() {
      this.form.operatorIds = []
      this.form.stationIds = []
      this.form.mechanismIds = []
      this.dialogVisible = false
    },
    cancel() {
      this.dialogVisible = false
      this.dialogVisible3 = false
    },
    async save() {
      try {
        // 必填校验
        await Promise.all([
          this.$refs.formUpdata.validate()
        ])
      } catch (error) {
        return
      }
      const data = {
        id: this.id,
        version: this.formUpdata.version
      }
      this.$store.dispatch('form/handle', {
        url: '/evserv/newApi/batchReUpdate',
        data: data,
        method: 'post',
        callback: resp => {
          this.dialogVisible3 = false
          this.$refs.tableref.queryTable()
          if (resp === null) {
            this.$notify({
              title: '成功',
              message: '远程升级指令已下发，请在电桩管理查看',
              type: 'success'
            })
          }
        }
      })
    },
    save1() {}
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

  <style lang="less" src="" scoped></style>



// WEBPACK FOOTER //
// src/views/plantManagement/plantManagement.vue